<span [innerHTML]="svgIcon"></span>
